// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tvd__toast{position:fixed;bottom:20px;right:20px;background-color:#333;color:#fff;padding:10px 20px;border-radius:4px;opacity:0;transition:opacity .3s ease;z-index:1000;box-shadow:0 2px 10px rgba(0,0,0,.2)}.tvd__toast.show{opacity:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
